import { render } from "./property-market.vue?vue&type=template&id=4cadd0d3"
import script from "./property-market.js?vue&type=script&lang=js"
export * from "./property-market.js?vue&type=script&lang=js"

import "./property-market.vue?vue&type=style&index=0&id=4cadd0d3&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__